import * as React from "react";
import { WebPage } from "@grandvisionhq/analytics";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const WebPageSchema = () => {
  const {
    activeVariant: { description },
    product: { brandName },
    productUrl
  } = useProductData();
  return /* @__PURE__ */ React.createElement(WebPage, { url: productUrl, pageType: "ProductDetail", name: brandName, description });
};
export {
  WebPageSchema
};
//# sourceMappingURL=WebPageSchema.js.map
